import { createStyles } from '@mui/styles';
import { APTheme } from "../../../core/TenantProvider/tenants";

export default (theme: APTheme) => createStyles({
  errorContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    justifyContent: 'center',
    padding: '0 15px'
  },
  errorHeader: {
    marginBottom: 10
  },
  mainImage: {
    '& img': {
      maxWidth: '100%',
      height: 'auto'
    },
    '@media(max-width: 768px)': {
      maxWidth: 200
    },
  },
  bodyContent: {
    margin: '50px 0 0',
    textAlign: 'center',
    '@media(max-width: 768px)': {
      marginTop: 30,
    },
  },
  buttons: {
    margin: '50px 0 0',
    '@media(max-width: 768px)': {
      marginTop: 30,
    },
    '& .MuiButton-root': {
      padding: '6px 24px',
      minWidth: 'auto'
    }
  }
});
